import { useState } from "react";

export const useDataViewState = ({
  initialDetailPanelPosition = "right",
} = {}) => {
  const [isDetailPanelOpen, setIsDetailPanelOpen] = useState(false);
  const [detailPanelPosition, setDetailPanelPosition] = useState(
    initialDetailPanelPosition
  );
  const [selectedBatchValue, setSelectedBatchValue] = useState("");
  const [downloadError, setDownloadError] = useState("");
  const [isBulkDownloading, setIsBulkDownloading] = useState(false);
  const [isSavingRecord, setIsSavingRecord] = useState(false);
  const [saveRecordError, setSaveRecordError] = useState("");
  const [isRevertingRecord, setIsRevertingRecord] = useState(false);
  const [revertRecordError, setRevertRecordError] = useState("");
  const [companyBulkError, setCompanyBulkError] = useState("");
  const [isMergingCompanies, setIsMergingCompanies] = useState(false);
  const [isDeletingCompanies, setIsDeletingCompanies] = useState(false);

  return {
    isDetailPanelOpen,
    setIsDetailPanelOpen,
    detailPanelPosition,
    setDetailPanelPosition,
    selectedBatchValue,
    setSelectedBatchValue,
    downloadError,
    setDownloadError,
    isBulkDownloading,
    setIsBulkDownloading,
    isSavingRecord,
    setIsSavingRecord,
    saveRecordError,
    setSaveRecordError,
    isRevertingRecord,
    setIsRevertingRecord,
    revertRecordError,
    setRevertRecordError,
    companyBulkError,
    setCompanyBulkError,
    isMergingCompanies,
    setIsMergingCompanies,
    isDeletingCompanies,
    setIsDeletingCompanies,
  };
};
